import React, { useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './Navbar.css';
import logo from '../assets/images/Fundswalle_Logo.png';

const Navbar = () => {
  const location = useLocation();

  useEffect(() => {
    const nav = document.getElementById('navbarNav');
    const toggler = document.querySelector('.navbar-toggler');
    if (nav?.classList.contains('show')) {
      toggler?.click();
    }
  }, [location]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      const nav = document.getElementById('navbarNav');
      const toggler = document.querySelector('.navbar-toggler');
      if (
        nav?.classList.contains('show') &&
        !nav.contains(e.target) &&
        !toggler.contains(e.target)
      ) {
        toggler?.click();
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  return (
    <div className="dwl-navbar-wrapper"> {/* Wrapper to ensure sticky */}
      <nav className="navbar navbar-expand-lg dwl-navbar-custom">
        <div className="container d-flex align-items-center justify-content-between">
          {/* Logo */}
          <NavLink className="navbar-brand dwl-navbar-brand" to="/">
            <img src={logo} alt="Fundswalle Logo" />
          </NavLink>

          {/* Toggle button */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Middle Menu */}
          <div className="collapse navbar-collapse justify-content-center" id="navbarNav">
            <ul className="navbar-nav dwl-nav-list">
              <li className="nav-item dwl-nav-item">
                <NavLink to="/" className="dwl-nav-link" end>Home</NavLink>
              </li>
              <li className="nav-item dwl-nav-item">
                <NavLink to="/about-us" className="dwl-nav-link">About Us</NavLink>
              </li>
              <li className="nav-item dwl-nav-item">
                <NavLink to="/contact-us" className="dwl-nav-link">Contact Us</NavLink>
              </li>
              <li className="nav-item dwl-nav-item">
                <NavLink to="/repay-loan" className="dwl-nav-link">Repay Loan</NavLink>
              </li>
            </ul>
          </div>

          {/* Right: Apply Now */}
          <div className="d-none d-lg-block">
            <NavLink to="/apply-now" className="dwl-apply-btn">
              Apply Now
            </NavLink>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
